export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/tangerine-flavor.d69a41b483f65480106dc4280eb6f29c.png";